// extracted by mini-css-extract-plugin
export var blue = "_1n-h";
export var brand = "_1n-d";
export var darkGrey = "_1n-g";
export var disabled = "_1n-6";
export var disabledSubtle = "_1n-7";
export var error = "_1n-8";
export var green = "_1n-i";
export var grey = "_1n-f";
export var icon = "_1n-0";
export var inherit = "_1n-c";
export var lightGrey = "_1n-e";
export var orange = "_1n-k";
export var pink = "_1n-m";
export var primary = "_1n-1";
export var purple = "_1n-n";
export var quaternary = "_1n-4";
export var quinary = "_1n-5";
export var red = "_1n-l";
export var secondary = "_1n-2";
export var success = "_1n-b";
export var tertiary = "_1n-3";
export var warning = "_1n-9";
export var warningSecondary = "_1n-a";
export var white = "_1n-o";
export var yellow = "_1n-j";